import * as React from "react";
import { useParams } from "react-router";
import { DrupalEmailErrorInfo } from "./DrupalEmailErrorInfo";
import { PageContainer } from "../../../../components";
import { useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { Card } from "@blueprintjs/core";
import styled from "styled-components";
import { DrupalWebUserPage } from "./DrupalWebUserPage";

export enum EDrupalMailError {
  NotExist = "NotExist",
  AccountExists = "AccountExists",
  MultipleMatch = "MultipleMatch",
  NoWebUser = "NoWebUser",
}

export interface IDrupalEmailErrorPageProps {}

const StyledCard = styled(Card)<{ height: number }>`
  width: 40%;
  height: ${({ height }) => height + "%"};
`;

export const DrupalEmailErrorPage: React.FunctionComponent<IDrupalEmailErrorPageProps> = () => {
  const { errorType } = useParams<{ errorType: string }>();
  const e = React.useMemo(() => EDrupalMailError[errorType], [errorType]);
  const { t } = useTl();

  const Error = React.useCallback(() => {
    switch (e) {
      case EDrupalMailError.NotExist: {
        return <DrupalEmailErrorInfo icon="fas fa-question fa-4x" text={t(ETLCodes.DrupalErrorEmailDoesNotExist)} />;
      }
      case EDrupalMailError.AccountExists: {
        return (
          <DrupalEmailErrorInfo
            icon="far fa-check-circle fa-4x"
            text={t(ETLCodes.DrupalErrorEmailAccountAlreadyExists)}
          />
        );
      }
      case EDrupalMailError.MultipleMatch: {
        return <DrupalEmailErrorInfo icon="fas fa-users fa-4x" text={t(ETLCodes.DrupalErrorEmailMultipleMatch)} />;
      }
      case EDrupalMailError.NoWebUser: {
        return (
          <DrupalEmailErrorInfo icon="fas fa-users fa-4x" text={t(ETLCodes.DrupalErrorExistingUserButNoAccount)} />
        );
      }
    }
  }, [e, t]);
  return (
    <PageContainer isCentered={true} isFullHeight={true}>
      <StyledCard height={e !== EDrupalMailError.NoWebUser ? 30 : 67}>
        {
          <div style={{ textAlign: "center" }}>
            <Error />
          </div>
        }
      </StyledCard>
    </PageContainer>
  );
};
